import { render } from "./softadd.vue?vue&type=template&id=56ab4f28&scoped=true"
import script from "./softadd.vue?vue&type=script&lang=js"
export * from "./softadd.vue?vue&type=script&lang=js"

import "./softadd.vue?vue&type=style&index=0&id=56ab4f28&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ab4f28"]])

export default __exports__